import { render, staticRenderFns } from "./commonboss.vue?vue&type=template&id=6a17d190&scoped=true&"
import script from "./commonboss.vue?vue&type=script&lang=js&"
export * from "./commonboss.vue?vue&type=script&lang=js&"
import style0 from "./commonboss.vue?vue&type=style&index=0&id=6a17d190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a17d190",
  null
  
)

export default component.exports